import React, { Component } from "react";
import { connect } from "react-redux";

import FloatHeader from "../theme/headers/FloatHeader";
import TurfDropoffMapModal from "../maps/TurfDropoffMapModal";
import * as doorCalls from "../../store/api/calls/doors";
import { pullCampaignCanvassers } from "../../store/api/calls";
import api from "../../store/api/api";
import { withRouter } from "../../utils/withRouter";

/*
 * Full-page dropoff assignment screen -- takes over from the old TurfDropoffMapModal
 * overlay that used to render on top of DoorSchedule. Layout is modeled after
 * TurfCutter.js: a FloatHeader for back-nav plus a full-viewport content area,
 * no NavBaseTemplate chrome.
 *
 * The actual map + canvasser-card UI is unchanged -- it's the same TurfDropoffMapModal
 * (which itself picks legacy vs uber based on the crew's transport_type) that DoorSchedule
 * used to mount as an overlay. We just host it here instead of inside a modal.
 */
class DoorCanvassDropOffs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      crewsReady: false,
    };
  }

  componentDidMount() {
    const { doorcanvass_id, shift_id } = this.props.params;

    // TurfDropoffMapModal reads crews (and, per-seat, canvasser names) synchronously
    // off props in its own componentDidMount, so make sure both are loaded into
    // redux before we mount it -- otherwise it can catch an empty list on first
    // load of this screen (e.g. a direct link or a refresh).
    //
    // DoorCrewViewSet.list() (the endpoint behind pullDoorCrews) filters by
    // canvass *and* the shift's date -- it has no way to filter by shift id
    // directly -- so look the shift up first to get its date.
    const crewsLoaded = api.get(`wox-shift/${shift_id}/`).then((res) =>
      doorCalls.pullDoorCrews({ canvass: +doorcanvass_id, date: res.data.shift_date })
    );
    const canvassersLoaded = pullCampaignCanvassers();

    Promise.all([crewsLoaded, canvassersLoaded]).then(() => {
      this.setState({ crewsReady: true });
    });
  }

  getBackLink = () => {
    const { doorcanvass_id } = this.props.params;
    return doorcanvass_id
      ? `/doorcanvass/${doorcanvass_id}/schedule`
      : "/doorcanvass";
  };

  render() {
    const { doorcanvass_id, shift_id } = this.props.params;
    const focusedCrewId = this.props.searchParams.get("crew");
    const focusedCrew = focusedCrewId
      ? this.props.crews.find((d) => d.id === +focusedCrewId)
      : null;

    return (
      <div id="door-canvass-dropoffs">
        <FloatHeader link={this.getBackLink()} />

        {this.state.crewsReady && (
          <TurfDropoffMapModal
            // TurfDropoffMapModalBase only resolves its crew/canvasser data once,
            // in componentDidMount. Since this route doesn't change path when you
            // navigate between two crews' dropoff pages for the same shift (only
            // ?crew= changes), React would otherwise reuse the same instance and
            // never re-run that logic -- force a remount by keying on shift+crew.
            key={`${shift_id}-${focusedCrewId || "default"}`}
            shift={+shift_id}
            crew={focusedCrewId ? +focusedCrewId : 0}
            // so the map can link a "this turf is too small" error straight to
            // that turf in Turf Cutter (needs a turf's canvass id to look up
            // which canvass pass it belongs to)
            doorcanvassId={+doorcanvass_id}
            // default to the Uber address path unless a crew has been explicitly
            // set to "driver" -- covers crews with no transport_type recorded yet
            useUber={focusedCrew?.transport_type !== "driver"}
            canvassers={this.props.canvassers}
            onClose={() => this.props.navigate(this.getBackLink())}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  crews: state.doorCrews.data,
  canvassers: state.canvassers.data,
});

export default connect(mapStateToProps)(withRouter(DoorCanvassDropOffs));
